<form class="routed-component-layout" (submit)="onSubmit($event)">

  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{'AUTH.APPLICATIONS.TITLE' | translate}}</h2>
    </div>

    @if (isDirect) {
      <p>{{ "AUTH.APPLICATIONS.PARAGRAPH_DIRECT" | translate }}</p>
    }
    <h3>{{ "AUTH.APPLICATIONS.SUBTITLE" + (isDirect ? '_DIRECT' : '') | translate}}</h3>
    <soldo-field-layout [control]="applicationControl" fieldName="application"
      cypressSelector="Auth_CardSelector_ApplicationList">
      <fieldset input class="card-group-layout">
        @for (app of applicationList; track app.id; let i = $index) {
          <label
            class="card application-card"
            [ngClass]="[app.status]"
            [attr.data-cy]="'Signup_Interactive_Application_' + i">
              <input type="radio"
                name="applicationSelection"
                [value]="getApplicationSelectionValue(app.id)" [formControl]="applicationControl"
                [attr.disabled]="isAppDisabled(app)"/>

              <div class="name-and-offer">
                <h4 [attr.translate]="'no'">
                  @if (app.company?.registeredName) {
                    {{ app.company.registeredName }}
                  } @else {
                    {{ "AUTH.APPLICATIONS.MISSING_COMPANY_NAME" | translate }}
                  }
                </h4>
                <span class="offer">{{ getOfferDescription(app) | async }}</span>
              </div>
              <span class="caption">{{ getStepLabel(app) | translate }}</span>
          </label>
        }
        @if (displayNewButton) {
          <label class="card application-card new clickable"
            data-cy="Signup_Interactive_Application_New">
            <input type="radio"
              [value]="newApplicationValue" [formControl]="applicationControl"
              name="applicationSelection" />
            <div class="name-and-offer">
              <h4>{{ "AUTH.APPLICATIONS.NEW_OPTION" | translate }}</h4>
              <span class="offer">{{ newOfferName }}</span>
            </div>
          </label>
        } @else if (displayAbandonAndChoosePlan) {
          <p>
            {{ "AUTH.APPLICATIONS.ABANDON_TEXT" | translate }},
            <button type="button" class="link no-padding" (click)="abandon()">{{ "AUTH.APPLICATIONS.ABANDON_LINK" | translate}}</button>.
          </p>
        }
      </fieldset>
      <ng-container errorMessage>
        <soldo-field-error error errorName="required">
          {{ 'AUTH.APPLICATIONS.APPLICATION_REQUIRED' | translate }}
        </soldo-field-error>
      </ng-container>
    </soldo-field-layout>
  </div>
  <div class="routed-component-cta">
    <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}"
      data-cy="Auth_Button_ApplicationSelectionButton">{{ 'AUTH.NEXT_SUB_STEP_BUTTON' | translate }}</button>
  </div>
</form>
